import head from 'lodash/head';
export function isLongIntroductionSectionEmpty() {
    return true;
}
export const getCurrentLongIntroductions = (currentSku, longIntroductionsVariants) => {
    if (currentSku) {
        return longIntroductionsVariants.find((item) => (item.sku = currentSku));
    }
    return head(longIntroductionsVariants);
};
